import React from 'react';
import { Box, Chip } from '@mui/material';

// 红球：01-33；蓝球：01-16
export default function BallPicker({
  type = 'red', // 'red' | 'blue'
  selected = [],
  onChange,
  maxSelect = 6,
  disabled = false,
}) {
  const isRed = type === 'red';
  const total = isRed ? 33 : 16;
  const color = isRed ? '#e53935' : '#1976d2';
  const balls = Array.from({ length: total }, (_, i) => String(i + 1).padStart(2, '0'));

  const toggle = (b) => {
    if (disabled) return;
    if (selected.includes(b)) {
      onChange(selected.filter((x) => x !== b));
    } else {
      if (selected.length >= maxSelect) {
        if (!isRed) {
          // 蓝球单选：直接替换
          onChange([b]);
        }
        return;
      }
      onChange([...selected, b].sort());
    }
  };

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {balls.map((b) => {
        const active = selected.includes(b);
        return (
          <Box
            key={b}
            onClick={() => toggle(b)}
            sx={{
              width: 38,
              height: 38,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 600,
              fontSize: 14,
              cursor: disabled ? 'not-allowed' : 'pointer',
              userSelect: 'none',
              border: `2px solid ${color}`,
              backgroundColor: active ? color : 'transparent',
              color: active ? '#fff' : color,
              opacity: disabled ? 0.5 : 1,
              transition: 'all 0.15s',
              '&:hover': disabled
                ? {}
                : {
                    transform: 'scale(1.06)',
                    boxShadow: `0 2px 8px ${color}66`,
                  },
            }}
          >
            {b}
          </Box>
        );
      })}
    </Box>
  );
}

// 用于回显已选号码（小球展示）
export function BallDisplay({ red = [], blue = '', size = 28 }) {
  const ballStyle = (color) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: size * 0.42,
    color: '#fff',
    backgroundColor: color,
    margin: '2px',
  });
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
      {red.map((r) => (
        <Box key={`r-${r}`} sx={ballStyle('#e53935')}>{r}</Box>
      ))}
      {blue && <Box sx={ballStyle('#1976d2')}>{blue}</Box>}
    </Box>
  );
}
